import {FetchMethodEnum, fetchX} from '../../util/fetch';
import {getCsrfHeaders, rootApiUrl} from '../api/api-const';

type UploadCustomReviewMediaResponseType = {
    url: string;
    key: string;
    type: 'image' | 'video';
};

const uploadCustomReviewMediaUrl = `${rootApiUrl}/v4/reviews/custom_reviews/media/`;

export function uploadCustomReviewMedia(file: File, brandId: number): Promise<UploadCustomReviewMediaResponseType> {
    const formData = new FormData();

    formData.append('brand_id', String(brandId));
    formData.append('file', file);

    return fetchX<UploadCustomReviewMediaResponseType>(uploadCustomReviewMediaUrl, {
        method: FetchMethodEnum.post,
        headers: {...getCsrfHeaders()},
        body: formData,
    });
}
